import { render } from "./student-multiple.vue?vue&type=template&id=1b9c64dd"
import script from "./student-multiple.vue?vue&type=script&lang=js"
export * from "./student-multiple.vue?vue&type=script&lang=js"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__